/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import spinner from "../../images/reports-spinner.gif";
import VoucherAccounting from "./VoucherAccounting";
import VoucherInventory from "./VoucherInventory";
import VoucherInventoryWaste from "./VoucherInventoryWaste";
import VoucherPurchaseInvoice from "./VoucherPurchaseInvoice";
import VoucherSaleInvoice from "./VoucherSaleInvoice";
import VoucherStockTransfer from "./VoucherStockTransfer";

// IMPORTING ICONS
import { ChevronUpIcon, ChevronDownIcon, MenuAlt2Icon } from "@heroicons/react/solid";
import { PencilIcon } from "@heroicons/react/outline";

// IMPORTING REACT-DATEPICKER
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Context from "../../context/context";

const columnsArray = [
  "Voucher Date",
  "Created At",
  "Voucher Number",
  "Voucher Type",
  "Amount",
];
const VOUCHER_TYPES = [
  {value:'', label: 'ALL'},
  {value:'INV', label: 'Inventory'},
  {value:'WA', label: 'Wastage Inventory'},
  {value:'ST', label: 'Stock Transfer'},
  {value:'PUR', label: 'Purchase'},
  {value:'SALE', label: 'Sale'},
  {value:'AC-REC', label: 'Receipt'},
  {value:'AC-PM', label: 'Payment'},
  {value:'AC-JO', label: 'Journal'},
  {value:'AC-CO', label: 'Contract'},
  {value:'AC-CRN', label: 'Credit Note'},
  {value:'AC-DN', label: 'Debit Note'},
]
export default function ReportsAllVouchers() { 
 
  const context = useContext(Context);
  const { setUnAuthPopup } = context;
  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || [];
  const [tableColumns, setTableColumns] = useState(null);
  const [dateformat, setDateformat] = useState(null);
  const [datefrom, setDatefrom] = useState(null);
  const [dateto, setDateto] = useState(null);
  const [filtersSelections, setFiltersSelections] = useState({});
  const [filtersRefCollection, setFiltersRefCollection] = useState(null);

  const [isDropDownVisible, setIsDropDownVisible] = useState(null);
  const [isMouseOutsideSidebar, setIsMouseOutsideSidebar] = useState(null);
  const [reportsRenderCollection, setReportsRenderCollection] = useState(null);
  const [reportsLength, setReportsLength] = useState(0);
  const [reportsData, setReportsData] = useState(null);
  const [pages, setPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isMouseOutsideDropDown, setIsMouseOutsideDropDown] = useState(null);
  const [orders_database, setOrders_database] = useState([]);

  const [table_loading, setTable_loading] = useState(null);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const getDateFormat=()=>{
      let DBOpenReq = window.indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      DBOpenReq.onerror = (err) => console.log(err);
      DBOpenReq.onsuccess = (ev) => {
        let db = ev.target.result;
        let getReq =  db.transaction("outlet", "readonly").objectStore("outlet").getAll();
        getReq.onsuccess = (data) => {
          let res = data.target.result[0];
          setTableColumns(columnsArray);
          setDatefrom(new Date(+res.current_working_day));
          setDateto(new Date(+res.current_working_day));
          setDateformat(
            res.setup.date_format
              .toLowerCase()
              .replaceAll("mm", "MM")
              .replaceAll("-", "/")
          );
        };
      };
    }
    getDateFormat();
  }, []);

  useEffect(() => {
    console.log("drop-down visiblity : ", isDropDownVisible);
    console.log("mouse outside sidebar : ", isMouseOutsideSidebar);
  }, [isDropDownVisible, isMouseOutsideSidebar])

  const generateRenderCollection = (vouchers) => {
    const renderCollection = [];

    function getDateTime(ms) {
      return `${new Date(
        +ms || ms
      ).toDateString()} at ${new Date(
        +ms || ms
      ).toLocaleTimeString()}`;
    }

    function getAmount(voucher) {
      if(voucher.voucher_type==='PUR'||voucher.voucher_type==='SALE')
      return Math.abs(voucher.grand_total);
      else if(voucher.voucher_type.includes('AC')){
        const amount = voucher.accounting?.reduce((a, b)=> a + +b.credit ,0);
        return Math.abs(amount);
      }else return '-';
    }

    vouchers.forEach(v => {
      const renderingObj = {
        "UUID": v.voucher_uuid,
        "Voucher Date": v.voucher_date && getDateTime(v.voucher_date),
        "Created At": v.created_at && getDateTime(v.created_at),
        "Voucher Number": v.voucher_number || '-',
        "Voucher Type": VOUCHER_TYPES.find(a=>v.voucher_type=== a.value)?.label || '',
        "Amount": getAmount(v) || '0',
      };
      renderCollection.push(renderingObj);
    });

    return renderCollection;
  }

  const pageLoad= (page) => {
    let content;
    const url = `https://api.myfooddo.com/voucher/ListVoucher:false`;
    // const url = `http://localhost:5000/voucher/ListVoucher:false`;
    document.querySelector(".tabular-content.report-orders-table").scrollTo(0, 0);
    setTable_loading(true);
    setLoading(false);
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        filters: filtersRefCollection,
        page: (+page),
        outlet_uuid: localStorage.getItem('outlet_uuid'),
        date_range: {
          from: new Date(datefrom).getTime(),
          to: new Date(dateto).getTime()
        }
      }),
    })
    .then(res => res.json())
    .then(data => {
      const renderingOrders = generateRenderCollection(data.result);
      content = data.result;
      console.log('data fetched from api --------- ', data.result);
      setOrders_database(content);
      setReportsRenderCollection(renderingOrders.splice(0, 50));
      setReportsData(renderingOrders);
      setTable_loading(false);
      setCurrentPage(page);
    })
    .catch(error => console.warn(error.message))
  }

  const onScroll = (e) => {
    if (reportsData.length < 1) return;
    setLoading(true);
    try {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        const data = reportsData;
        setReportsRenderCollection( reportsRenderCollection.concat(data.splice(0, 50)));
        setReportsData(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error)
    }
  };

  const searchHandler=()=> {
    let timeDifference = (new Date(parseFloat(localStorage.getItem("current-working-day")))).getDate() - datefrom.getDate();
    if (restrictions.length && (parseInt(restrictions[0]?.other_report_order) || 0) < timeDifference) {
      setUnAuthPopup(true)
      setTimeout(() => setUnAuthPopup(false), 3000)
      return
    }
    setTable_loading(true);
    setLoading(false);

    try {
      
      const fSelections = {};
      const filters = [
        "Voucher Type",
      ];

      // set value refs
      filters.forEach((f, ind, arr) => {
        const selection = [];
        if (document.getElementsByClassName(`${f.toLowerCase().replace(" ", "-")}`)[0].querySelector('#all').checked === true) {
          Array.from(document.querySelectorAll(`[name="${f}"]`)).forEach(
            (e, i, arr) => {
              const value = e.getAttribute("label-value");
              if (e.checked) {
                if (value.toLocaleLowerCase() !== "all") selection.push(f==="Voucher Type" ? VOUCHER_TYPES.find(a=> a.label===value).value :value);
              }
              if (++i === arr.length) fSelections[f] = selection;
            }
          );
        }else{
          Array.from(document.querySelectorAll(`[name="${f}"]`)).forEach(
            (e, i, arr) => {
              const value = e.getAttribute("label-value");
              if (e.checked) selection.push(f==="Voucher Type" ? VOUCHER_TYPES.find(a=> a.label===value).value :value);
              if (++i === arr.length) fSelections[f] = selection;
            }
          );
        }
        if (ind + 1 === arr.length)
          setFiltersRefCollection(fSelections);
      });

      let content;
      const url = `https://api.myfooddo.com/voucher/ListVoucher:true`;
      // const url = `http://localhost:5000/voucher/ListVoucher:true`;
      const bodyReq = {
        filters: fSelections,
        page: 1,
        date_range: {
          from: new Date(datefrom).getTime(),
          to: new Date(dateto).getTime()
        },
        outlet_uuid: localStorage.getItem('outlet_uuid')
      }
      console.log(url, bodyReq)
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(bodyReq),
      })
      .then(res => res.json())
      .then(data => {
        content = data.result;
        console.log('data fetched from api --------- ', data.result);
        setTable_loading(false);
        if (content) {
          if (+content?.length === 0) return setTable_loading(false);
          if (content?.length) {
            let pages = [];
            let total_pages = Math.ceil((+content?.length) / 200);
            setReportsLength(content?.length)
            for (let i = 1; i <= total_pages; i++) {
              pages.push(i)
            }
            setPages(pages);
          }
          setOrders_database(content);
          // setFilteredLocalReports([]);

          const renderingOrders = generateRenderCollection(content);
          // console.log("Rendering collection", renderingOrders);

          setReportsRenderCollection(renderingOrders.splice(0, 50));
          setReportsData(renderingOrders);

          setCurrentPage(1);
        }
      })
      .catch(err => console.warn("post request failed", err));
    } catch (error) {
      console.error(error);
      setTable_loading(false);
    }
  }

  return (
    <div className="accountGroup">
      <h1>All Vouchers</h1>
      
      <div id="filters-container" >
        <div className="filters-form">
          <div className="inputs-container"
            onClick={() => {
              if (isMouseOutsideDropDown) { setIsDropDownVisible(null)}
              if (isMouseOutsideSidebar) {
                document.querySelector("#filters-sidebar").classList.remove("active");
                document.querySelector("#sidebar-container").classList.remove("active");
              }
            }}
          >
            <button
              id="filters-popup-trigger"
              onClick={() => {
                document.querySelector("#filters-sidebar").classList.toggle("active");
                document.querySelector("#sidebar-container").classList.toggle("active");
              }}
              onMouseEnter={() => {setIsMouseOutsideSidebar(false);}}
              onMouseLeave={() => {setIsMouseOutsideSidebar(true);}}
            >
              <MenuAlt2Icon style={{ width: "40px" }} />
            </button>

            {dateformat && (
              <>
                <div
                  className="selection-field date-field from orders-page"
                  onClick={() => {
                    setIsDropDownVisible(null);
                    document
                      .querySelector("#filters-sidebar")
                      .classList.remove("active");
                    document
                      .querySelector("#sidebar-container")
                      .classList.remove("active");
                  }}
                >
                  <label htmlFor="date-from">From date</label>
                  <DatePicker
                    id="date-from"
                    className="date-picker test"
                    dateFormat={dateformat}
                    selected={datefrom}
                    maxDate={new Date()}
                    onChange={(date) => {
                      setDatefrom(date);
                      setDateto(date);
                      document.getElementById('date-to').click();
                      document.getElementById('date-to').focus();
                    }}
                    shouldCloseOnSelect={true}
                  />
                </div>
                <div
                  className="selection-field date-field to orders-page"
                  onClick={() => {
                    setIsDropDownVisible(null);
                    document
                      .querySelector("#filters-sidebar")
                      .classList.remove("active");
                    document
                      .querySelector("#sidebar-container")
                      .classList.remove("active");
                  }}
                >
                  <label htmlFor="date-to">To date</label>
                  <DatePicker
                    id="date-to"
                    className="date-picker test"
                    dateFormat={dateformat}
                    minDate={datefrom}
                    selected={dateto}
                    // maxDate={Date.now()}
                    onChange={(date) => {
                      setDateto(date)
                    }}
                    wrapperClassName=""
                    shouldCloseOnSelect={true}
                  />
                </div>
              </>
            )}

            <button id="filters-search-btn" 
            onClick={(e) => searchHandler()}
            >
              Search
            </button>

            <div id="rightSided">

              <div className="report-stats container">
                <span>
                  {/* Total Amount : Rs.{totalAmount || 0} */}
                </span>
                <span>
                  Total Records : {reportsLength}
                </span>
              </div>
            </div>
          </div>
          <div id="sidebar-container"
            onClick={() => {
              if (isMouseOutsideSidebar) {
                setIsDropDownVisible(null);
                document
                  .querySelector("#filters-sidebar")
                  .classList.remove("active");
                document
                  .querySelector("#sidebar-container")
                  .classList.remove("active");
              }
            }}
          >
            <div
              id="filters-sidebar"
              onMouseEnter={() => {
                setIsMouseOutsideSidebar(false);
              }}
              onMouseLeave={() => {
                setIsMouseOutsideSidebar(true);
              }}

              onClick={() => {
                if (isMouseOutsideDropDown) {
                  setIsDropDownVisible(null);
                }
              }}
            >
              <h1>All filters</h1>
              <div>
                <div
                  className="sidebar-row"
                  onMouseEnter={() => setIsMouseOutsideDropDown(false)}
                  onMouseLeave={() => setIsMouseOutsideDropDown(true)}
                >
                  <FilterElement
                    key={Math.random()}
                    id={Math.random()}
                    title={"Voucher Type"}
                    options={VOUCHER_TYPES?.map(a=>a.label)}
                    isDropDownVisible={isDropDownVisible}
                    setIsDropDownVisible={setIsDropDownVisible}
                    filtersSelections={filtersSelections}
                    setFiltersSelections={setFiltersSelections}
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="table-container"
            onClick={() => {
              if (isMouseOutsideDropDown) {
                setIsDropDownVisible(null)
              }
            }}
            style={{ paddingBottom: pages?.length > 1 ? "35px" : '0' }}
          >
            {table_loading && <div id="reports-loading-spinner" style={{top: '200px', zIndex: '1'}}>
              <img src={spinner} alt="loading reports" />
            </div>}
            <Table
              tableColumns={tableColumns}
              reportsRenderCollection={reportsRenderCollection}
              setReportsRenderCollection={setReportsRenderCollection}
              onScroll={onScroll}
              loading={loading}
              pages={pages}
              pageLoad={pageLoad}
              orders_database={orders_database}
              currentPage={currentPage}
              searchHandler={searchHandler}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

function Table({
  tableColumns,
  reportsRenderCollection,
  setReportsRenderCollection,
  onScroll,
  loading,
  pages,
  pageLoad,
  orders_database,
  currentPage,
  searchHandler
}) {
  const [tempOrders, setTempOrders] = useState(null);
  const [isOrdersTablePopUpOpen, setIsOrdersTablePopUpOpen] = useState(null);
  const [orderTableData, setOrderTableData] = useState({});

  useEffect(() => {
    if (tempOrders) {
      // console.log("temp orders : ", tempOrders);
      setReportsRenderCollection(tempOrders);
    }
    return setTempOrders(null);
  }, [tempOrders, orderTableData]);

  const sortFunctions = {
    Voucher_Date: function (op) {
      const vouchers = reportsRenderCollection;

      if (op === "asc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Date"] && !b["Voucher Date"]) return 0;
          else return ( new Date(a["Voucher Date"].replace(" at", "")) - new Date(b["Voucher Date"].replace(" at", "")) );
        });
      else if (op === "desc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Date"] && !b["Voucher Date"]) return 0;
          else return ( new Date(b["Voucher Date"].replace(" at", "")) - new Date(a["Voucher Date"].replace(" at", "")) );
        });

      setTempOrders(vouchers);
    },

    Created_At: function (op) {
      const vouchers = reportsRenderCollection;

      if (op === "asc")
      vouchers.sort((a, b) => {
          if (!a["Created At"] || !b["Created At"]) return 0;
          else
            return (
              new Date(a["Created At"].replace(" at", "")) -
              new Date(b["Created At"].replace(" at", ""))
            );
        });
      else if (op === "desc")
      vouchers.sort((a, b) => {
          if (!a["Created At"] || !b["Created At"]) return 0;
          else
            return (
              new Date(b["Created At"].replace(" at", "")) -
              new Date(a["Created At"].replace(" at", ""))
            );
        });

      setTempOrders(vouchers);
    },

    Voucher_Number: function (op) {
      const vouchers = reportsRenderCollection;

      if (op === "asc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Number"] && !b["Voucher Number"]) return 0;
          else return a["Voucher Number"].localeCompare(b["Voucher Number"]);
        });
      else if (op === "desc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Number"] && !b["Voucher Number"]) return 0;
          else return b["Voucher Number"].localeCompare(a["Voucher Number"]);
        });

      setTempOrders(vouchers);
    },

    Voucher_Type: function (op) {
      const vouchers = reportsRenderCollection;

      if (op === "asc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Type"] && !b["Voucher Type"]) return 0;
          else return a["Voucher Type"].localeCompare(b["Voucher Type"]);
        });
      else if (op === "desc")
      vouchers.sort((a, b) => {
          if (!a["Voucher Type"] && !b["Voucher Type"]) return 0;
          else return b["Voucher Type"].localeCompare(a["Voucher Type"]);
        });

      setTempOrders(vouchers);
    },

    Amount: function (op) {
      const vouchers = reportsRenderCollection;

      if (op === "asc") {
        vouchers.sort((a, b) => {
          if (!a["Amount"] && !b["Amount"]) return 0;
          else return ( +a["Amount"] - +b["Amount"] );
        });
      } else if (op === "desc") {
        vouchers.sort((a, b) => {
          if (!a["Amount"] && !b["Amount"]) return 0;
          else return ( +b["Amount"] - +a["Amount"] );
        });
      }
      setTempOrders(vouchers);
    },
  };

  const toggleOrderTable = (uuid)=> {
    const _order = orders_database.find(v => v.voucher_uuid === uuid);
    setIsOrdersTablePopUpOpen(true);
    setOrderTableData({ id: uuidv4() + uuidv4(), status: true, value: _order });
  }

  const close = () =>{
    setIsOrdersTablePopUpOpen(false);
  };

  return (
    <>
    {isOrdersTablePopUpOpen && orderTableData?.value?.voucher_type==='INV' &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherInventory
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
    {isOrdersTablePopUpOpen && orderTableData?.value?.voucher_type==='WA' &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherInventoryWaste
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
    {isOrdersTablePopUpOpen && orderTableData?.value?.voucher_type==='PUR' &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherPurchaseInvoice
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
    {isOrdersTablePopUpOpen && orderTableData?.value?.voucher_type==='SALE' &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherSaleInvoice
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
    {isOrdersTablePopUpOpen && orderTableData?.value?.voucher_type==='ST' &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherStockTransfer
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
    {isOrdersTablePopUpOpen && (
      orderTableData?.value?.voucher_type==='AC-REC' || 
      orderTableData?.value?.voucher_type==='AC-PM' || 
      orderTableData?.value?.voucher_type==='AC-JO' || 
      orderTableData?.value?.voucher_type==='AC-CO' || 
      orderTableData?.value?.voucher_type==='AC-DN' || 
      orderTableData?.value?.voucher_type==='AC-CRN' ) &&
      <div className="itemavilablelity" style={{ left: "-100px" }}>
        <div className="orderDetailsContainer" >
          <VoucherAccounting
            type='edit'
            value={orderTableData?.value}
            close={close}
          />
        </div>
      </div>
    }
      <div
        onScroll={(e) => onScroll(e)}
        className="tabular-content report-orders-table"
      >  
      {reportsRenderCollection && reportsRenderCollection.length > 0 ? (
        <table>
          <thead>
            <tr>
              {reportsRenderCollection &&
                reportsRenderCollection.length > 0 &&
                tableColumns &&
                tableColumns.map((column) => {
                  return (
                    <th key={Math.random()}>
                      <div className="t-head-element">
                        <span>{column}</span>
                        <div className="sort-buttons-container">
                          <button
                            onClick={() =>
                              sortFunctions[column.replaceAll(" ", "_")]("asc")
                            }
                          >
                            <ChevronUpIcon className="sort-up sort-button" />
                          </button>
                          <button
                            onClick={() =>
                              sortFunctions[column.replaceAll(" ", "_")]("desc")
                            }
                          >
                            <ChevronDownIcon className="sort-down sort-button" />
                          </button>
                        </div>
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
          {reportsRenderCollection.map((voucher, i) => {
            return (
              <tr className="report-fields"
                key={i}
                onClick={() => toggleOrderTable(voucher["UUID"])}
              >
                {tableColumns &&
                  tableColumns.map((label) =>
                    label === "Local Order No" ? (
                      <td
                        key={Math.random()}
                        className={`${label
                          .toLowerCase()
                          .replaceAll(" ", "_")}`}
                      >
                        {voucher[label] || "-"}
                      </td>
                    ) : (
                      <td
                        key={Math.random()}
                        className={`${label
                          .toLowerCase()
                          .replaceAll(" ", "_")}`}
                      >
                        {voucher[label] || "-"}
                      </td>
                    )
                  )}
              </tr>
            );
          })}
          </tbody>
        </table>
      ) : (
        <div id="no_reports">No Vouchers</div>
      )}

        {loading && (
          <div id="loadingDiv">
            <img src={spinner} alt="loading..." />
          </div>
        )}

        {pages && pages.length > 1 && 
          <div className="pagination orders-report">
          {pages.map(p =>
            <div className={+currentPage === +p ? "active" : ""} onClick={() => pageLoad(p)}>
              {p}
            </div>
          )}
          </div>
        }
      </div>
    </>
  );
}

function FilterElement({
  title,
  id,
  options,
  tableColumns,
  setTableColumns,
  isDropDownVisible,
  setIsDropDownVisible,
  filtersSelections,
  setFiltersSelections,
}) {

  function handleSelection() {
    const notAllSelected = Array.from(
      document.querySelectorAll(`[name = "${title}"]`)
    )
      .splice(1)
      .some((element) => element.checked === false);

    if (notAllSelected)
      document
        .querySelector(`[container = "${id}"]`)
        .querySelector('[id="all"]').checked = false;
    else
      document
        .querySelector(`[container = "${id}"]`)
        .querySelector('[id="all"]').checked = true;

    let selection = [];
    Array.from(document.querySelectorAll(`[name = "${title}"]`)).forEach(
      (element, i, array) => {
        element.checked &&
          element.getAttribute("label-value") !== "All" &&
          selection.push(element.getAttribute("label-value"));

        if (++i === array.length)
          setFiltersSelections({ ...filtersSelections, [title]: selection });
      }
    );
  }

  function toggleDropdown(e) {
    e.preventDefault();
    console.log('toggled dropdown');
    console.log(isDropDownVisible);
    setIsDropDownVisible(isDropDownVisible !== title ? title : null);
  }

  function autoSelectAll() {
    const notAllSelected = Array.from(
      document.querySelectorAll(`[name = "${title}"]`)
    ).some((element) => element.checked === false);

    if (notAllSelected) document.getElementById("all").checked = false;
    else document.getElementById("all").checked = true;
  }

  function selectAllHandler(e) {
    e.preventDefault();
    const checked = e.currentTarget.querySelector("input").checked;

    if (checked) {
      setFiltersSelections({ ...filtersSelections, [title]: [] });
      title === "Edit Columns" && setTableColumns(["Local Order No"]);
    } else {
      setFiltersSelections({ ...filtersSelections, [title]: options });
      title === "Edit Columns" && setTableColumns(options.slice(1));
    }
    e.currentTarget.parentNode.childNodes.forEach((i, index, array) => {

      i.querySelector("input").checked = !checked;
    });
  }

  function handleColumns(e) {
    autoSelectAll();
    let editColumns = tableColumns;
    const isChecked = e.currentTarget.checked;
    const label = e.currentTarget.getAttribute("label-value");

    editColumns = editColumns.filter((i) => i !== label);

    isChecked && editColumns.push(label);
    setTableColumns(editColumns);
  }

  useEffect(() => {

    if (!Array.isArray(tableColumns) || tableColumns.length === 0) return;
    if (title !== "Edit Columns") return;

    let DBOpenReq = window.indexedDB.open(
      "FoodDo",
      +localStorage.getItem("IDBVersion") || 1
    );
    DBOpenReq.onerror = (err) => console.log(err);

    DBOpenReq.onsuccess = (ev) => {
      let db = ev.target.result;
      let store = db.transaction("user", "readwrite").objectStore("user");
      let getReq = store.get(localStorage.getItem("user_uuid"));

      getReq.onsuccess = (userRes) => {
        const user = userRes.target.result;
        user.past_order_columns = tableColumns;
        store.put(user);
      };
    };
  }, [tableColumns]);

  return (
    <div
      tabIndex="0"
      container={id}
      container-title={title}
      className="selection-field"
    >
      {title !== "Edit Columns" && <div className="field-title">{title}</div>}

      <button
        className="dropdown-trigger"
        onClick={(e) => toggleDropdown(e)}
      >
        {title === "Edit Columns" && <PencilIcon id="edit-columns-pencil" />}
        <span id="trigger-text">
          {title !== "Edit Columns" &&
            filtersSelections[title] &&
            filtersSelections[title].includes("ALL") ? (
            <span>ALL</span>
          ) : title !== "Edit Columns" &&
            filtersSelections[title] &&
            filtersSelections[title].length > 0 ? (
            filtersSelections[title].slice(0, 2).map((i) => <span>{i}</span>)
          ) : (
            title !== "Edit Columns" && <span>None</span>
          )}
          {title === "Edit Columns" && ` ${title}.${tableColumns.length} `}
        </span>
        <span className="arrow"></span>
      </button>

      {title !== "Edit Columns" &&
        filtersSelections[title] &&
        filtersSelections[title].length > 0 && (
          <div className="show-selections">
            {filtersSelections[title].map((i) => <div key={i}>{i}</div>)}
          </div>
        )}

      <div className={`dropdown ${title.toLowerCase().replace(" ", "-")} ${isDropDownVisible === title ? "visible" : ""} `}>
        {options.map((opt) => (
          <div
            key={Math.random()}
            className="input-div"
            onClick={(e) => opt.toLowerCase() === "all" && selectAllHandler(e)}
            lable={opt}
          >
            <label>
              <input
                type="checkbox"
                name={title}
                id={opt.toLowerCase()}
                label-value={opt}
                onChange={(e) =>
                  title === "Edit Columns"
                    ? handleColumns(e)
                    : handleSelection()
                }

                disabled={title === "Edit Columns" && opt === "Local Order No" ? true : false}
                defaultChecked={
                  title === "Edit Columns" &&
                    ((opt.toLowerCase() === "all" &&
                      options.length === tableColumns.length + 1) ||
                      tableColumns.includes(opt))
                    ? true
                    : title !== "Edit Columns" &&
                      filtersSelections[title] &&
                      opt.toLowerCase() === "all" &&
                      options.length === filtersSelections[title].length + 1
                      ? true
                      : filtersSelections[title] &&
                        filtersSelections[title].includes(opt)
                        ? true
                        : false
                }
              />
              <div className="checkmark"></div>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
